import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'pf-content-collapsible',
    templateUrl: './content-collapsible.component.html',
    styleUrls: ['./content-collapsible.component.scss'],
    standalone: false,
})
export class ContentCollapsibleComponent {
    @Input() pfHeader: string | TemplateRef<void> | undefined;
    @Input() active = false;
}
